<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="guardar()" appPermissionControl="P290F0001">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="opcion" class="form-control" 
                [placeholder]="'Ingrese la nueva opción'" appPermissionControl="P290K0001">
            <label>Opción</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="guardar()"
        [disabled]="!form.valid || loading" appPermissionControl="P290B0001">
        <mat-icon>save</mat-icon>
        Guardar
    </button>
        <button mat-flat-button type="button" class="btn-delete btn-menu" (click)="cancelar()" appPermissionControl="P290B0002">
            <mat-icon>close</mat-icon>
            Cancelar
        </button>
    </div>
</form>